<template>
  <div class="ima-copy-sign-modal">

    <div class="ima-copy-sign-modal__form">


      <b-field label="Name*">
            <b-input v-model="name" :required="true" ref="autofocus"></b-input>
          </b-field>
    </div>


      <b-field label="Neuer Schildtyp*">
          <b-select v-model="type" placeholder="Auswählen" required icon="web" expanded>
            <option v-for="option in options.types" :value="option" :key="option.id">
              {{ option.name }} (ID: {{option.id}})
            </option>
          </b-select>
       </b-field>



    <div :style="{'text-align': 'right'}">
      <button type="button" class="button is-success" :disabled="!isValidForm || signs.data.isSaving" @click="onConfirm">
        <span>Kopieren</span>
      </button>
      <button type="button" class="button is-danger" @click="onCancel">Abbrechen</button>
    </div>

  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import inform from '@/services/inform'
import { closeModals } from '@/store/modules/modals'
import { copySign, unselectSignToCopy } from '@/store/modules/signs'

import modals from '@/mixins/modals'

export default {
  name: 'ima-copy-sign-modal',
  data () {
    return {
      name: null,
      type: null
    }
  },
  created () {
    this.name = `${this.signs.selectedSign.name} - Kopie`
  },
  computed: {
    ...mapState(['signTypes', 'signs']),
    sign () {
      return this.signs.selectedSign
    },
    isValidForm () {
      return this.name && this.name.length && !!this.type
    },
    options () {
      return {
        types: this.signTypes.data
      }
    }
  },
  mixins: [modals],
  methods: {
    ...mapMutations([closeModals, unselectSignToCopy]),
    ...mapActions([copySign]),
    onConfirm () {
      const { sign, name, type } = this
      this.copySign({ sign, newName: name, newSignType: type.id }).then(() => {
        this.closeModals()
        inform(`"${sign.name}" erfolgreich kopiert`)
      })
    },
    onCancel () {
      this.unselectSignToCopy()
      this.closeModals()
    }
  }
}
</script>

<style scoped lang="scss">
.ima-copy-sign-modal {
  &__form {
    display: flex;
    margin-bottom: 1rem;

    .field {
      flex-grow: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/CopySignModal.vue